// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"H_1mgZScKYhNXTRTltUI","badgeText":"u7HtSsnp5sg9ZMMDYCwO"};